module.exports = __webpack_public_path__ + "static/media/agd_accred.f8912234.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/agd_accred.png
// module id = 498
// module chunks = 0